import { Component } from '@angular/core';
import {
  AppHeaderComponent
} from '../../../shared/standalone-components/layout-components/headers/app-header/app-header.component';
import {
  AppFooterComponent
} from '../../../shared/standalone-components/layout-components/footers/app-footer/app-footer.component';
import {RouterLink} from '@angular/router';
import {IconifyComponent} from '../../../shared/standalone-components/iconography/iconify/iconify.component';

@Component({
  selector: 'bor-error404',
  standalone: true,
  templateUrl: './error404.component.html',
  styleUrl: './error404.component.scss',
  imports: [
    AppHeaderComponent,
    AppFooterComponent,
    RouterLink,
    IconifyComponent
  ]
})
export class Error404Component {}
